import { getFileFormat, getMediaExtension } from '@/utils/helper'

import { CreateItem } from '@a4b/api/src/modules/Monetisation/Puja/types'

type CreateItemWithId = CreateItem & { id: string }

export const formatItemCreation = (formData: any, language_code: string, country_code: string): CreateItemWithId => {
  console.log({ formData }, 'formData')
  const formatedObject: CreateItemWithId = {
    id: formData.id,
    title: formData.title,
    description: formData.description,
    price: Number(formData.price),
    item_type: formData.item_type,
    image_url: formData.image_url?.[0],
    // bottomsheet_image_url: formData.bottomsheet_image_url?.[0],
    bottomsheet_medias: formData?.bottomsheet_medias?.map((image: string) => {
      const fileExtension = getMediaExtension(image)
      const mediaType = fileExtension ? getFileFormat(fileExtension) : 'image'
      return { media_type: mediaType, media_url: image }
    }),
    is_igst: formData.is_igst,
    hsn_code: formData.hsn_code || null,
    tax_rate:
      formData?.tax_rate === '' || formData?.tax_rate == null
        ? null
        : Number(formData?.tax_rate),
    slug: formData.slug,
    batch_size: Number(formData.batch_size),
    quantities: Number(formData.quantities),
    member_size: Number(formData.member_size),
    language_code: language_code,
    currency: formData?.currency,
    country_code: country_code,
    specificity: formData.specificity,
    bullet_icon_url: formData.bullet_icon_url?.[0],
    additional_info_v2: formData?.additional_info_v2,
    multi_add: formData.multi_add,
    deliverable: formData.deliverable,
    short_name: formData.short_name,
  }
  return formatedObject
}
